var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconChevronLeft = function SvgIconChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.67 1.965a1.548 1.548 0 0 0-2.072.107l-8.763 8.763a1.546 1.546 0 0 0 0 2.189l8.763 8.764a1.549 1.549 0 0 0 2.189-2.19l-7.668-7.669 7.668-7.668a1.547 1.547 0 0 0 .106-2.072l-.106-.118-.118-.106z",
    fill: "#292A2C",
    fillRule: "evenodd"
  })));
};

export default SvgIconChevronLeft;